import { useRouter } from 'next/router'
import cn from 'classnames'
import Button from '../newButton/Button'
import styles from './Keypad.module.scss'
import Image from 'next/legacy/image'
import { rgbDataURL } from '../puppyProfile/lib/utils'
import { handleReserve } from './lib/handlers'
import ButtonAsk from './lib/buttonAsk'

export default function Keypad({
  dog,
  showImage,
  salePrice,
  dataApplication,
  updatedData,
}) {
  const router = useRouter()

  if (!updatedData?.isAvailable) {
    return (
      <div className={cn(styles.keypad, styles.notAvailable)}>
        <img src="/puppy/family-house.svg" alt="family house icon" />

        <h4>This puppy has found a forever home.</h4>

        <Button
          title="Browse Others"
          onClick={() => router.push('/search')}
          theme={['medium', 'pink-solid']}
          style={{ width: '280px' }}
        />
      </div>
    )
  }

  return (
    <div className={styles.keypad}>
      {showImage && (
        <div className={styles.image}>
          <Image
            width={290}
            height={290}
            src={`${process.env.NEXT_PUBLIC_MEDIA_BUCKET}${dog?.profilePicture?.medium}`}
            placeholder="blur"
            blurDataURL={rgbDataURL(238, 238, 238)}
            alt={dog.name}
          />
        </div>
      )}

      {salePrice !== isNaN && salePrice > 0 && (
        <div className={styles.buttons}>
          <ButtonAsk special dataPuppy={updatedData} />

          <Button
            title="Take me home"
            theme={['medium', 'green-solid']}
            onClick={() => handleReserve(dog, router, dataApplication)}
            style={{
              width: '100%',
            }}
          />
        </div>
      )}
    </div>
  )
}
